// Single source of truth for finance formatting (expects RAW dollars).
export const formatCurrencyShort = (n) => {
  if (n == null || isNaN(Number(n))) return "—";
  const v = Number(n);
  const a = Math.abs(v);
  if (a >= 1e9)  return `$${(v/1e9).toFixed(1)}B`;
  if (a >= 1e6)  return `$${(v/1e6).toFixed(1)}M`;
  if (a >= 1e3)  return `$${(v/1e3).toFixed(1)}K`;
  return `$${Math.round(v)}`;
};
